import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';
import CaretLink from 'modules/Common/components/CaretLink';

export default function ErrorPage({title, children}) {
  require('./ErrorPage.scss');

  const errorPixelSrc = `/1x1.gif?type=page&id=${title}&cb=${Date.now()}`;

  return (
    <div className="error-page">
      <Helmet title={title}/>
      <div className="error-heading">
        <h1 className="page-title">{title}</h1>
        <p className="error-message">{children}</p>
      </div>
      <div className="error-links">
        <p>Here are some helpful links:</p>
        <div className="error-link"><CaretLink to="/racing">Horse Racing</CaretLink></div>
        <div className="error-link"><CaretLink to="/football">Football</CaretLink></div>
        <div className="error-link"><CaretLink to="/greyhounds">Greyhound Racing</CaretLink></div>
        <div className="error-link"><CaretLink to="/cricket">Cricket</CaretLink></div>
        <div className="error-link"><CaretLink to="/darts">Darts</CaretLink></div>
        <div className="error-link"><CaretLink to="/golf">Golf</CaretLink></div>
      </div>
      <div>
        <img src={errorPixelSrc} width="1" height="1" />
      </div>
    </div>
  );
}

ErrorPage.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};



// WEBPACK FOOTER //
// ./modules/Errors/components/ErrorPage.js